import type { ReactNode } from 'react';

/**
 * "You can read this page; you cannot act on it."
 *
 * The 2026-09-22 ruling ("a plain TRFer should be able to read the TRF-wide
 * application") turns a page that used to be hidden into a page that is
 * visible but inert for some readers. A reader who is shown controls that
 * always fail is worse off than one who is shown none: Settings → Applications
 * offered three live radio cards to a reader whose PATCH returns 403, and the
 * toast said "Please try again" for a request that can never succeed.
 *
 * So the rule these surfaces follow is: hide the control AND say why. This
 * component is the second half. Three callers use it — the applications queue,
 * the application record, and the Applications tab of Settings.
 *
 * The colour pair is lifted verbatim from `AdminHandoffConfigPage`, which
 * carried the first hand-rolled version of this banner and a comment asking
 * for exactly this primitive. That page is deliberately NOT migrated here: its
 * copy branches on why the reader is read-only, and rewriting it is not this
 * change's business.
 */
export function ReadOnlyNotice({ children }: { children: ReactNode }) {
  return (
    <div
      role="status"
      data-testid="read-only-notice"
      className="rounded-md border border-status-warn-border bg-status-warn px-4 py-3 text-body-sm text-status-warn-fg"
    >
      Read-only view. {children}
    </div>
  );
}
